import { RouteConfig } from "vue-router";
import Layout from "@/layout/index.vue";

const systemManagementRoutes: RouteConfig[] = [
  {
    path: "/system-management",
    component: Layout,
    redirect: "/system",
    name: "SystemManagement",
    meta: {
      title: "systemManagement",
      icon: "el-icon-s-tools",
    },
    children: [
      {
        path: "configuration",
        component: () =>
          import("@/views/system-management/configuration/index.vue"),
        redirect: "/system/permission",
        name: "SystemConfiguration",
        meta: { title: "systemConfiguration" },
        children: [
          {
            path: "user",
            component: () =>
              import("@/views/system-management/configuration/user/index.vue"),
            name: "UserManagement",
            meta: { title: "userManagement" },
          },
          {
            path: "supplier-management",
            component: () =>
              import(
                "@/views/system-management/configuration/supplier-management/index.vue"
              ),
            name: "SupplierManagement",
            meta: { title: "supplierManagement" },
          },
          {
            path: "/information-card-management",
            component: () =>
              import(
                "@/views/system-management/configuration/information-card-management/index.vue"
              ),
            name: "InformationCardManagement",
            meta: { title: "informationCardManagement" },
          },
        ],
      },
      {
        path: "permission",
        component: () =>
          import("@/views/system-management/permission/index.vue"),
        redirect: "/system/permission",
        name: "PermissionManagement",
        meta: { title: "permissionManagement" },
        children: [
          {
            path: "role-management",
            component: () =>
              import(
                "@/views/system-management/permission/role-management/index.vue"
              ),
            name: "RoleManagement",
            meta: { title: "roleManagement" },
          },
          {
            path: "job-position",
            component: () =>
              import(
                "@/views/system-management/permission/job-position-management/index.vue"
              ),
            name: "JobPositionManagement",
            meta: { title: "jobPositionManagement" },
          },
        ],
      },
      {
        path: "template",
        component: () => import("@/views/system-management/template/index.vue"),
        redirect: "/system/template",
        name: "TemplateManagement",
        meta: { title: "templateManagement", alwaysShow: true },
        children: [
          {
            path: "factory-delivery-note-template",
            component: () =>
              import(
                "@/views/system-management/template/FactoryDeliveryNoteTemplate.vue"
              ),
            name: "FactoryDeliveryNoteTemplate",
            meta: { title: "factoryDeliveryNoteTemplate" },
          },
          {
            path: "warehouse-in-charge-template",
            component: () =>
              import(
                "@/views/system-management/template/WarehouseInChargeTemplate.vue"
              ),
            name: "WarehouseInChargeTemplate",
            meta: { title: "warehouseInChargeTemplate" },
          },
        ],
      },
      {
        path: "information",
        component: () =>
          import("@/views/system-management/information/index.vue"),
        name: "Information",
        meta: { title: "informationMaintenance", alwaysShow: true },
        children: [
          {
            path: "container-type",
            component: () =>
              import(
                "@/views/system-management/information/ContainerTypeConfiguration.vue"
              ),
            name: "ContainerTypeConfiguration",
            meta: { title: "containerTypeConfiguration" },
          },
          {
            path: "declaration-element",
            component: () =>
              import(
                "@/views/system-management/information/DeclarationElement.vue"
              ),
            name: "DeclarationElement",
            meta: { title: "declarationElement" },
          },
          {
            path: "financial",
            component: () =>
              import("@/views/system-management/information/financial/financial.vue"),
            name: "Financial",
            meta: { title: "financial" },
          },
        ],
      },
      {
        path: "/productBusinessManagement",
        name: "productBusinessManagement",
        component: () =>
          import("@/views-oms/product-business-management/index.vue"),
        meta: {
          title: "productBusinessManagement",
        },
        children: [
          {
            path: "/productNumberTypeManagement",
            name: "ProductNumberTypeManagement",
            component: () =>
              import(
                "@/views-oms/product-business-management/product-hierarchy-management/number/type/index.vue"
              ),
            meta: { title: "productNumberTypeManagement" },
          },
          {
            path: "/hqTransactionNumberManagement",
            name: "hqTransactionNumberManagement",
            component: () =>
              import(
                "@/views-oms/product-business-management/hq-product-hierarchy-management/number/type/index.vue"
              ),
            meta: { title: "hqTransactionNumberManagement" },
          },
          {
            // 表格
            path: "/productCategoryManagement",
            name: "productCategoryManagement",
            component: () =>
              import(
                "@/views-oms/product-business-management/product-hierarchy-management/list.vue"
              ),
            meta: { title: "productCategoryManagement" },
          },
          {
            // 表格
            path: "/hqSnManagement",
            name: "hqSnManagement",
            component: () =>
              import(
                "@/views-oms/product-business-management/hq-product-hierarchy-management/list.vue"
              ),
            meta: { title: "hqSnManagement" },
          },
          {
            // 表格
            path: "/productSystemManagement",
            name: "productSystemManagement",
            component: () =>
              import(
                "@/views-oms/product-business-management/product-hierarchy-management/ProductSystemManagement.vue"
              ),
            meta: { title: "productSystemManagement" },
          },
          {
            path: "/productNumberManagement",
            name: "ProductNumberManagement",
            component: () =>
              import(
                "@/views-oms/product-business-management/product-hierarchy-management/number/index.vue"
              ),
            meta: { title: "productNumberManagement", hidden: true },
          },
          {
            path: "/hqProductNumberManagement",
            name: "hqProductNumberManagement",
            component: () =>
              import(
                "@/views-oms/product-business-management/hq-product-hierarchy-management/number/index.vue"
              ),
            meta: {
              title: "hqProductNumberManagement",
              activeMenu: "/hqSnManagement",
              hidden: true,
            },
          },
          {
            path: "/productNumberUnitList",
            name: "ProductNumberUnitList",
            component: () =>
              import(
                "@/views-oms/product-business-management/product-hierarchy-management/number/unit/index.vue"
              ),
            meta: { title: "productNumberUnitList", hidden: true },
          },
          {
            path: "/hqProductNumberUnitList",
            name: "hqProductNumberUnitList",
            component: () =>
              import(
                "@/views-oms/product-business-management/hq-product-hierarchy-management/number/unit/index.vue"
              ),
            meta: {
              title: "hqProductNumberUnitList",
              activeMenu: "/hqSnManagement",
              hidden: true,
            },
          },
          // {
          //   path: "/productNumberUnitMove",
          //   name: "ProductNumberUnitMove",
          //   component: () =>
          //     import(
          //       "@/views-oms/product-business-management/product-hierarchy-management/number/unit/move.vue"
          //     ),
          //   meta: { title: "ProductNumberUnitMove", hidden: true },
          // },
        ],
      },
      {
        path: "/systemLog",
        component: () => import("@/views/system-management/systemLog/index.vue"),
        name: "systemLog",
        meta: { title: "systemLog" },
      },
      {
        path: "/appVersion",
        component: () => import("@/views/app-version/AppVersion.vue"),
        name: "appVersionControl",
        meta: { title: "appVersionControl" },
      },
      {
        path: "/account-type",
        component: () => import("@/views-oms/setAccounts/setAccounts.vue"),
        name: "accountType",
        meta: { title: "accountType" },
      },
    ],
  },
];

export default systemManagementRoutes;
